var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { IntlUtilsBase } from './base';
import { withI18nDeps } from './withI18nDeps';
export class IntlUtilsServer extends IntlUtilsBase {
    constructor() {
        super(...arguments);
        this.getStaticPaths = () => __awaiter(this, void 0, void 0, function* () {
            return ({
                fallback: false,
                paths: this.languages.map((language) => ({
                    params: {
                        [this.config.languageParamName]: language,
                    },
                })),
            });
        });
        /**
         * getStaticProps middleware
         * @param ctx
         * @returns
         */
        this.withI18nDeps = (props, mode = 'ssg') => {
            const middleware = withI18nDeps(Object.assign(Object.assign({}, props), { defaultLanguage: this.config.defaultLanguage }));
            return (ctx) => {
                var _a;
                const localeOfCtx = mode === 'ssr'
                    ? ctx.locale
                    : (_a = ctx.params) === null || _a === void 0 ? void 0 : _a[this.config.languageParamName];
                return middleware({
                    locale: this.getLanguageWithFallback(typeof localeOfCtx === 'string' ? localeOfCtx : undefined),
                });
            };
        };
    }
}
